import client from "lib/api/client"

export const getSchedules = () => {
  return client.get("/tournaments_masters")
}

export const getPreviousSchedule = () => {
  return client.get("/tournaments_masters/previous")
}
